import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Injeta o token Bearer automaticamente em toda requisição, lendo direto do
// authStore (fora de qualquer componente React — useAuthStore.getState()).
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  // Envio de arquivo precisa de multipart/form-data COM o boundary, que só o
  // navegador sabe gerar. Mantendo o Content-Type padrão de JSON, o PHP não
  // enxerga o arquivo e a tela acusa "nenhum arquivo escolhido".
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// Em qualquer 401 (token ausente/expirado/revogado), limpa o authStore e
// redireciona para o login. ProtectedRoute é só UX — esta é a reação real
// a uma sessão inválida.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      useAuthStore.getState().clearAuth();
      window.location.href = '/login';
    }

    // Senha provisória: a API só responde à troca, então a tela vai para lá.
    if (err.response?.status === 403 && err.response.data?.trocar_senha && window.location.pathname !== '/trocar-senha') {
      window.location.href = '/trocar-senha';
    }
    return Promise.reject(err);
  },
);

export default api;
